export const roofIds = [
	// Generic CA/US
	'roofSolidBlocking',
	'roofVentedBlocking',
	'roofTrussToTrussConnections',
	'roofTrussToBeamConnections',
	'roofTrussToLedgerConnections',
	'roofDimensionalRafters',
	'roofDimensionalBeams',
	'roofEwp',
	'roofCeilingJoist',
	'roofPosts',
	'roofSheathing',
	// from BV
	'roofDormerTrusses',
	'roofValleyTrusses', // ROME-2699
	'roofHangers',
	'roofEwpColumns', // ROME-2550
	// [ROME-3373] for UK
	// 'roofSolidBlocking', already existing
	'roofTrussToGirder',
	'roofTrussToInternalLBW',
	'roofTrussToBeam',
	'roofPurlinesBinderSpans',
	'roofCeilingJoists',
	'roofPlyBracingDiaphramPlyBracing',
	'roofNoggins',
	// 'roofEwp', already existing
	'roofRimJoist',
	'roofRimBoard',
	// [ROME-4419] for UK / Anglian Timber Limited
	'roofInfillRaftersHipboards',
	'roofTrimmersForLoftHatches',
	'roofInverterPlatforms',
	'roofStabilityBracing',
	'roofGablePanels',
	'roofPartyWallPanels',
	'roofGablePanelsMetalwork',
	'roofPartyWallPanelsMetalwork',
	'roofGableLadders',
	'roofLateralRestraintStrapsAssociatedNogginTimber',
	'roofWallPlatesRestraintStraps',
	'roofMetalwork',
	'roofGirderTrussBottomChordFixings',
	'roofValleyPlywoodAssociatedSupportNoggins',
	'roofSoffitFraming',
	'roofFasciaBackers',
	'roofCeilingBattens',
	'roofPlywood',
	'roofSolidBlockingTimberToSteelBeams',
	// ROME-5595 custom for United SW
	'roofEwpFlush',
	'roofEwpDropped',
	'roofTrussToTrussHardware',
	'roofTrussToBearingHardware',
] as const;

export const floorIds = [
	// Generic CA/US
	'floorTrussToTrussConnections',
	'floorTrussToBeamConnections',
	'floorTrussToLedgerConnections',
	'floorSquashBlocking',
	'floorDimensionalJoists',
	'floorDimensionalBeams',
	'floorRimJoist',
	'floorRibbonMaterial',
	'floorEwp',
	'floorPosts',
	'floorSheathingAndGlue',
	// from BV
	'floorTruss',
	'floorJoist',
	'floorHangers',
	'floorEwpColumns', // ROME-2550
	// [ROME-3373] for UK
	'floorSpaceJoistToGirder',
	'floorSpaceJoistToTrimmer',
	'floorSpaceJoistToBeam',
	'floorDimensionalSpan',
	// 'floorRimJoist', already existing
	'floorRimBoard',
	// 'floorEwp', already existing
	'floorDeckingAndD4Glue',
	'floorBlocking',
	'floorBeamSpans',
	'floorNoggins',
	// 'floorPosts', already existing
	'floorTimberFrame',
	'floorMasonryBlockwork',
	// [ROME-4419] for UK / Anglian Timber Limited
	'floorLateralRestraintStrapsAndAssociatedNogginTimber',
	'floorPlywoodForEnhancedHangerInstallation',
	'floorSolidBlockingTimberToSteelBeams',
	'floorMultiPlyJoistConnectors',
	'floorMultiPlyTimberConnector',
	'floorUZClipsForNogginsSupport',
	// ROME-5595 custom for United SW
	'floorEwpFlush',
	'floorEwpDropped',
	'floorTrussToTrussHardware',
	'floorTrussToBearingHardware',
] as const;

export const frameIds = [
	// Generic CA/US
	'frameSheathing',
	'frameStrapping',
	'frameHouseWrap',
	'frameDimensionalBeams',
	'frameEwp',
	// [ROME-3373] for UK
	'frameOSB',
	'frameBreatherPaper',
	// 'frameEwp', already existing
	'frameRestraintStraps',
	'frameHeadBinder',
	'frameRingBeam',
	// ROME-5595 custom for United SW
	'frameEwpHeaders',
	'frameEwpColumns',
] as const;

export const ewpIds = [
	'ewpRimJoist',
	'ewpJoistToBeamConnection',
	'ewpJoistToLedgerConnection',
	'ewpBlocking',
	'ewpLVLBeams',
	// from BV
	'ewpIJoist',
	'ewpTrimJoist',
	'ewpRim',
	'ewpBeams',
	'ewpPosts',
	'ewpIJoistRafters',
	'ewpRidgeBeams',
	'ewpHangers',
	'ewpHeaders',
] as const;

export const wholeHouseIds = [
	'wholeHouseFoundation',
	'wholeHouseFoundationBasement',
	'wholeHouseBlockWork', // [ROME-4780] Promoted to main list of take off types (was Carters).
	'wholeHouseFraming',
	'wholeHouseIntFraming', // [ROME-6749] New addition for internal framing take off types.
	'wholeHouseExtFraming',
	'wholeHouseFramingMaterial', // [ROME-6075] Big River VIC Prefab
	'wholeHouseFlooring', // [ROME-4752] Replaces 'flooring' requirement.
	'wholeHouseDecksAndPorches',
	'wholeHouseWindows',
	'wholeHouseDoors',
	'wholeHouseCeilings', // [ROME-4780] Promoted to main list of take off types (was Carters).
	'wholeHouseInsulation',
	'wholeHouseRoofing',
	'wholeHouseEavesSoffits', // [ROME-6075] Big River VIC Prefab
	'wholeHouseGutters',
	'wholeHouseDrywall',
	'wholeHouseMillwork',
	'wholeHouseInteriorFinishes',
	'wholeHouseExteriorFinishes',
	'wholeHouseIntWallCladding', // [ROME-4780] Promoted to main list of take off types. (was Carters)
	'wholeHouseExtWallCladding', // [ROME-4642] Promoted to main list of take off types (was Carters).
	'wholeHouseIntFixtures', // [ROME-4780] Promoted to main list of take off types (was Carters).
	'wholeHouseFireRatedSystems', // [ROME-4780]
	'wholeHouseHardware', // [ROME-4780]
	'wholeHouseDimensionalFloorRoofLayout', // ROME-6133  // TO be added to US templates
	'wholeHouseEwpFloorRoofLayout', // ROME-6133  // TO be added to US templates
	'wholeHouseOpenings', // ROME-6133  // TO be added to US templates
	'wholeHouseFlatRoofing', // ROME-6133  // TO be added to US templates
] as const;

export const multiLevelWholeHouseIds = [
	'wholeHouseFoundation',
	'wholeHouseFoundationBasement',
	'wholeHouseFraming',
	'wholeHouseIntFraming',
	'wholeHouseExtFraming',
	'wholeHouseFlooring',
	'wholeHouseDecksAndPorches',
	'wholeHouseWindows',
	'wholeHouseDoors',
	'wholeHouseCeilings',
	'wholeHouseInsulation',
	'wholeHouseDrywall',
	'wholeHouseMillwork',
	'wholeHouseInteriorFinishes',
	'wholeHouseExteriorFinishes',
	'wholeHouseIntWallCladding',
	'wholeHouseExtWallCladding',
	'wholeHouseIntFixtures',
] as const;

export const ids = [...roofIds, ...floorIds, ...frameIds, ...ewpIds, ...wholeHouseIds] as const;
